var React = require('react');
var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
var Utils = require('../../utils/Utils');

var createReactClass = require('create-react-class');
var UpdateTitle = createReactClass({
    // Set the application title according to the client ID 

    render: function () {
        let clientId = this.props.clientId ? this.props.clientId : '';
        Utils.setTitleKey(clientId, this.props.intl)
        return (
            <div>
            </div>
        );

    }
});

module.exports = injectIntl(UpdateTitle);
